<template>
  <V2AtomsBaseCard
    radius="small"
    size="2x-small"
    :class="[cardClasses, wrapperClass]"
    :style="cardSizingStyles"
    :to="$attrs.to"
    :data-testid="dataTestid"
  >
    <slot>
      <img
        v-if="image"
        alt="image"
        class="w-full h-auto"
        loading="lazy"
        :src="image"
        v-bind="imageAttrs"
      />
    </slot>
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesCardImageCard',
  inheritAttrs: false
})

const $attrs = useAttrs()

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'image-card'
  },

  // Local Images are stored under /public/images/authors
  image: {
    type: String,
    default: ''
  },

  cardWidth: {
    type: [String, Number],
    default: 80
  },

  size: {
    type: String,
    default: '2x-small',
    validator: value => ['2x-small', 'x-small', 'small', 'base', 'large'].includes(value)
  },

  wrapperClass: {
    type: String,
    default: ''
  },

  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'transparent'].includes(value)
  }
})

const imageAttrs = computed(() => {
  const attrs = Object.assign({}, $attrs)
  delete attrs.to

  return attrs
})

const cardClasses = computed(() => {
  const baseClasses = 'flex items-center justify-center'

  if (props.variant === 'transparent') {
    return `${baseClasses} !border-transparent !bg-transparent`
  }

  return `${baseClasses} border-2 border-semantic-outline-variant-light !bg-blue`
})

const cardSizingStyles = computed(() => {
  const widthValue = String(props.cardWidth)
  const formattedWidth = widthValue.endsWith('px') ? widthValue : `${widthValue}px`

  return {
    width: formattedWidth,
    height: formattedWidth
  }
})
</script>